import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Listing from "./Listing";
import { useLocation } from "react-router-dom";
import { acceptCookyPolicy } from "app/pages/.shared/CookiePolicyFooter/cookiePolicyActionCreators";
import { clearProduct, fetchProducts } from "app/pages/Listing/productActionCreators";
import { productShape } from "app/utils/propTypes";
import Loader from "app/pages/.shared/Loader";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { sendTagOnListingLoad } from "app/utils/analytics";
import get from "lodash/get";
import { parseQueries } from "app/utils/routerUtils";
import { getPartnerCode, getPartnerListingSEO } from "app/reducers/partnerSelector";
import { getCurrentShop } from "app/reducers/shopSelector";
import { fetchMerchandisings } from "app/pages/Merchandising/merchandisingActionCreators";
import { clearBooking } from "app/pages/Booking/bookingActionCreators";
import { HitType, useFlagship } from "@flagship.io/react-sdk";
import { FLAGSHIP_SCREENVIEW_KPIS } from "app/constants";

const ListingContainer = props => {
	const {
		clearProduct,
		productsVisibility,
		shop,
		partnerCode,
		fetchProducts,
		fetchMerchandisings,
		acceptCookyPolicy,
		clearBooking,
	} = props;
	const [loading, setLoading] = useState(true);
	const location = useLocation();
	const { hit: fsHit } = useFlagship();

	useEffect(() => {
		fsHit.sendMultiple([
			{
				type: HitType.PAGE_VIEW,
				documentLocation: window.location.origin + window.location.pathname,
			},
			{
				type: HitType.SCREEN_VIEW,
				documentLocation: FLAGSHIP_SCREENVIEW_KPIS.SCREENVIEW_PP_LISTING,
			},
		]);
	}, []);

	useEffect(() => {
		fetchProducts({ productsVisibility, shop, partnerCode }).then(res => {
			setLoading(false);
			clearBooking();
			const products = get(res, "data.products", []);
			sendTagOnListingLoad(products.slice(0, 3));
		});

		fetchMerchandisings({ productsVisibility, shop, partnerCode });

		// pour ne pas avoir des données de la dernière fiche produit consultée s'afficher brièvement
		// à l'ouverture d'une fiche produit dans un onglet
		clearProduct();

		return () => {
			clearProduct();
			acceptCookyPolicy();
		};
	}, [productsVisibility, shop, partnerCode]);

	const query = parseQueries(location.search);

	return (
		<>
			<Listing
				idSpotlight={query.spotlight}
				{...props}
				/**
				 * on affiche le nombre de produits que
				 * lorsque la requête côté front est finie
				 */
				displayProductsCount={loading === false}
			/>
			{loading && (
				<div className="listing__loader">
					<Loader />
				</div>
			)}
		</>
	);
};

ListingContainer.propTypes = {
	route: PropTypes.object,
	fetchProducts: PropTypes.func,
	fetchMerchandisings: PropTypes.func,
	clearProduct: PropTypes.func,
	clearBooking: PropTypes.func,
	acceptCookyPolicy: PropTypes.func,
	products: PropTypes.arrayOf(productShape),
	setProductsFilter: PropTypes.func,
	setProductsFilters: PropTypes.func,
	productsFilters: PropTypes.object,
	resolution: PropTypes.string,
	productsVisibility: PropTypes.string,
	shop: PropTypes.string,
	partnerCode: PropTypes.string,
	listingSEO: PropTypes.object,
};

const mapStateToProps = state => {
	return {
		brand: state.brand.code,
		shop: getCurrentShop(state),
		partnerCode: getPartnerCode(state),
		productsVisibility: state.productsVisibility,
		productsFilters: state.productsFilters,
		resolution: state.resolution,
		listingSEO: getPartnerListingSEO(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			fetchMerchandisings,
			fetchProducts,
			clearProduct,
			acceptCookyPolicy,
			clearBooking,
		},
		dispatch
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ListingContainer);
